export default {
	"billContent": {
		"isRequired": "จำเป็นหรือไม่",
		"limit": "ค่าขีดจำกัด",
		"defaultValue": "ค่าเริ่มต้น",
		"fixedValue": "มูลค่าคงที่",
		"otherStyle": "อื่นๆ",
		"RangeValue": "ค่าพิกัด"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/product/product.js